module.exports = __webpack_public_path__ + "static/width-6eb68b191b5f7aafaebd88aabfe2f23c.gif";